<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>SOLICITAÇÕES - {{ tipoSolicitacao.titulo }}</span>
                    <div class="float-right">
                        <span class="text-primary">
                            <i
                                class="fa fa-refresh fa-lg icon-button"
                                title="Atualizar"
                                @click.stop="obterSolicitacoes()"
                            ></i>
                        </span>
                    </div>
                </h4>
                <b-row>
                    <b-col sm="12" md="4">
                        <b-form-group>
                            <strong>
                                <label>Filtro por Status</label>
                            </strong>
                            <b-form-select
                                :plain="true"
                                :options="statusOptions"
                                v-model="status"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <app-tabela
                    :itens="solicitacoes"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                >
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <app-btn-voltar></app-btn-voltar>
                            <!-- <b-button
                                variant="success"
                                @click="inserirTipoMovimento()"
                                v-if="$temAcessoView('ADMIN-TIPOMOV-01')"
                                >Inserir Tipo de Movimento</b-button
                            > -->
                        </b-button-group>
                    </template>
                    <!-- <template slot="acoes" slot-scope="data">
                        <span
                            class="text-primary"
                            v-if="$temAcessoView('ADMIN-TIPOMOV-01')"
                        >
                            <i
                                class="fa fa-info-circle fa-lg icon-button"
                                title="Detalhar"
                                @click.stop="detalhar(data.codMov)"
                            ></i>
                        </span>
                    </template> -->
                    <template slot="HEAD_objeto">
                        {{ tipoSolicitacao.tituloObjeto }}
                    </template>
                    <template slot="objeto" slot-scope="data">
                        <span
                            class="icon-button textLink"
                            @click="toObjeto(data.objetoId)"
                            >{{ data.objeto }}</span
                        >
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import tiposSolicitacoes from './TiposSolicitacoes'
import statusOptions from './StatusOptions'

export default {
    components: {},

    props: {
        tipo: {
            type: Number
        },

        dataServicos: {
            type: Object,
            default: () => {}
        },

        toObjeto: {
            type: Function
        }
    },

    data() {
        return {
            solicitacoes: [],
            statusOptions: statusOptions,
            status: 0,
            campos: [
                {
                    key: 'dataAbertura',
                    label: 'Data Abertura',
                    sortable: true,
                    tdClass: 'text-center',
                    type: 'datetime'
                },
                {
                    key: 'objeto',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'justificativaAbertura',
                    label: 'Justificativa Abertura',
                    filterable: true
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    sortable: true,
                    filterable: true,
                    type: 'status'
                },
                {
                    key: 'justificativaFinalizacao',
                    label: 'Justificativa Finalização',
                    filterable: true
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    sortable: true,
                    tdClass: 'text-center',
                    type: 'datetime'
                }
                // {
                //     key: 'acoes',
                //     label: 'Ações'
                // }
            ],
            itensPorPagina: 10
        }
    },
    methods: {
        obterSolicitacoes() {
            this.$store.dispatch('addRequest')
            this.dataServicos.obterSolicitacoes(this.status).then(response => {
                if (response) {
                    if (response.success) {
                        this.solicitacoes = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter solicitações',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {
        this.obterSolicitacoes()
    },

    computed: {
        tipoSolicitacao() {
            return tiposSolicitacoes[this.tipo]
        }
    },

    watch: {
        status() {
            this.obterSolicitacoes()
        }
    }
}
</script>
